import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\62877\\Documents\\NAYVERA\\node_modules\\lucide-react\\dist\\esm\\Icon.mjs");
;
import(/* webpackMode: "eager" */ "C:\\Users\\62877\\Documents\\NAYVERA\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\62877\\Documents\\NAYVERA\\src\\components\\Navbar.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\62877\\Documents\\NAYVERA\\src\\components\\ui\\AppImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\62877\\Documents\\NAYVERA\\src\\components\\ui\\AppLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\62877\\Documents\\NAYVERA\\src\\components\\WhatsAppFloat.tsx");
